module.exports = __webpack_public_path__ + "img/1_seibi-car-sp.9262386c.gif";